"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetAllInspectionsResponseDto = instanceOfGetAllInspectionsResponseDto;
exports.GetAllInspectionsResponseDtoFromJSON = GetAllInspectionsResponseDtoFromJSON;
exports.GetAllInspectionsResponseDtoFromJSONTyped = GetAllInspectionsResponseDtoFromJSONTyped;
exports.GetAllInspectionsResponseDtoToJSON = GetAllInspectionsResponseDtoToJSON;
exports.GetAllInspectionsResponseDtoToJSONTyped = GetAllInspectionsResponseDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var ListingInspectionItemDto_1 = require("./ListingInspectionItemDto");
/**
 * Check if a given object implements the GetAllInspectionsResponseDto interface.
 */
function instanceOfGetAllInspectionsResponseDto(value) {
    if (!('inspections' in value) || value['inspections'] === undefined)
        return false;
    return true;
}
function GetAllInspectionsResponseDtoFromJSON(json) {
    return GetAllInspectionsResponseDtoFromJSONTyped(json, false);
}
function GetAllInspectionsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
        'inspections': (json['inspections'].map(ListingInspectionItemDto_1.ListingInspectionItemDtoFromJSON)),
    };
}
function GetAllInspectionsResponseDtoToJSON(json) {
    return GetAllInspectionsResponseDtoToJSONTyped(json, false);
}
function GetAllInspectionsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
        'inspections': (value['inspections'].map(ListingInspectionItemDto_1.ListingInspectionItemDtoToJSON)),
    };
}
